<script>
import SoMe from "@/components/bottomSoMe.vue";

const BASE = "https://apps.gogolith.com";
const DEFAULT_TITLE = "Gogolith — iOS & Apple Watch Apps";
const DEFAULT_DESC =
  "Lightweight, privacy-friendly fitness apps for iPhone, iPad & Apple Watch — Cycle Unit, Rowing Workout, Jack Rope and more.";
const DEFAULT_IMAGE = `${BASE}/og/cover-1200x630.png`;

export default {
  name: "App",
  components: { SoMe },
  metaInfo() {
    const url = `${BASE}${this.$route.path || "/"}`;

    return {
      title: DEFAULT_TITLE,
      link: [{ rel: "canonical", href: url, vmid: "canonical" }],
      meta: [
        { name: "description", content: DEFAULT_DESC, vmid: "description" },

        { property: "og:type", content: "website", vmid: "og:type" },
        { property: "og:title", content: DEFAULT_TITLE, vmid: "og:title" },
        {
          property: "og:description",
          content: DEFAULT_DESC,
          vmid: "og:description",
        },
        { property: "og:url", content: url, vmid: "og:url" },
        { property: "og:image", content: DEFAULT_IMAGE, vmid: "og:image" },

        {
          name: "twitter:card",
          content: "summary_large_image",
          vmid: "twitter:card",
        },
        {
          name: "twitter:title",
          content: DEFAULT_TITLE,
          vmid: "twitter:title",
        },
        {
          name: "twitter:description",
          content: DEFAULT_DESC,
          vmid: "twitter:description",
        },
        {
          name: "twitter:image",
          content: DEFAULT_IMAGE,
          vmid: "twitter:image",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Gogolith",
            url: BASE,
            logo: `${BASE}/icon/android-icon-192x192.png`,
          },
          vmid: "org-jsonld",
        },
      ],
    };
  },
};
</script>

<template>
  <div id="app">
    <div class="app_top_cta">
      <SoMe />
    </div>

    <div id="nav">
      <router-link to="/"
        >Home
        <span class="subnav">
          <div class="arrow-up"></div>

          <router-link to="/rowingworkoutapp">Rowing </router-link>
          <router-link to="/skiingworkoutapp">Skiing </router-link>
          <router-link to="/cyclingworkoutapp">Cycling </router-link>
          <router-link to="/intervalsapp">Intervals </router-link>
          |
          <router-link to="/cycle-unit">Cycle Unit </router-link>
          <router-link to="/workoutgpt">WorkoutGPT</router-link>
        </span>
      </router-link>

      <router-link to="/support">Support</router-link>
      <router-link to="/privacy">Privacy</router-link>
      <router-link to="/imprint">Imprint</router-link>
    </div>
    <router-view />
    <SoMe />
  </div>
</template>

<style lang="scss">
$color_main: #ccc;
$color_main_act: #89d100;
$font1: "sf pro rounded", -apple-system, Helvetica, Arial, sans-serif;
$font2: "sf pro rounded", -apple-system, Helvetica, Arial, sans-serif;

body {
  background: #333;
  background-size: cover;
  background-attachment: fixed;
  font-size: 18px;
  color: $color_main;
  margin: 0;
}

a {
  color: $color_main;
  font-weight: bold;
}

h1 {
  font-size: 1.5rem;
  font-family: $font2;
  color: #fff;
}
h2 {
  font-size: 1.35rem;
  font-family: $font2;
  color: #fff;
}
h3 {
  font-size: 1.2rem;
  font-family: $font2;
  color: #fff;
}

@media all and (min-width: 360px) {
  h1 {
    font-size: 1.87rem;
    color: #fff;
  }
  h2 {
    font-size: 1.6rem;
    color: #fff;
  }
  h3 {
    font-size: 1.3rem;

    color: #fff;
  }
}

.app_bottom_cta {
  display: block;
  text-align: center;
  img {
    width: 256px;
    margin: 20px;
  }
}

.tns-nav {
  display: none;
}

.tns-outer {
  button {
    display: none;
  }
}

#app {
  font-family: $font1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $color_main;
  margin-bottom: 50px;
}

.subnav {
  position: absolute;
  display: inline;
  top: 51px;
  left: -30px;
  font-size: 0.7em;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 4px 5px 4px 5px;
  opacity: 0;
  white-space: nowrap;

  @media all and (min-width: 486px) {
    padding: 2px 10px 3px 10px;
    top: 56px;
    left: 20px;
  }
}

.router-link-active {
  .subnav {
    opacity: 1;
  }
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #484848;
  position: absolute;
  left: 60px;
  top: -6px;
  @media all and (min-width: 486px) {
    left: 40px;
  }
}

#nav {
  padding: 12px 20px 10px 20px;
  background: #fff;
  background: rgba(255, 255, 255, 0.1);
  font-size: 16px;
  border-radius: 20px;
  margin: 20px auto 45px auto;
  display: inline-block;
  font-family: $font2;
  position: relative;

  a {
    text-decoration: none;
    padding: 3px 4px 4px 4px;
    color: $color_main;

    &.router-link-exact-active {
      color: $color_main_act;
    }
  }
  @media all and (min-width: 600px) {
    transform: translateX(-80px);
    margin: 20px auto 35px auto;
  }
  @media all and (min-width: 486px) {
    padding: 13px 30px 13px 30px;
    font-size: 18px;
    a {
      padding: 10px;
    }

    .subnav {
      a {
        padding: 5px;
      }
    }
  }
}

.app_top_cta {
  position: absolute;
  left: 125px;
  margin-left: 50%;
  display: none;

  @media all and (min-width: 600px) {
    display: block;
  }

  top: 17px;

  img {
    width: 170px;
  }
}
</style>
